import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '@banyan/modules/account/services/account.service';
import { CartService } from '@banyan/modules/cart/services/cart.service';

@Component({
  selector: 'app-cart-table',
  templateUrl: './cart-table.component.html',
  styleUrls: ['./cart-table.component.scss'],
})
export class CartTableComponent {
  @Input() dataSource: any;
  @Input() displayedColumns: any;
  @Input() total: any;
  updatingCart: boolean = false;
  currency: string = '';
  accountService = inject(AccountService);
  router = inject(Router);
  cartService = inject(CartService);

  constructor() {
  }

  updateCart(
    productId: number | null,
    lineId: string,
    quantity: number | null,
  ): void {
    this.updatingCart = true;
    this.cartService.updateCart(productId, null, lineId, quantity ?? null);
  }

  goToCheckout() {
    this.router.navigate(['/protected/checkout']).then();
  }
}
